let msg = [
    {
        path: '/message/base',
        name: 'base',
        component: () => import('@/views/message/base/list.vue'),
        meta: {keepAlive: true, parentPath: 'message'},
    },
    {
        path: '/message/base/edit',
        name: 'edit',
        component: () => import('@/views/message/base/edit.vue'),
        meta: {keepAlive: true, parentPath: 'message'},
    },
    {
        path: '/message/comment',
        name: 'comment',
        component: () => import('@/views/message/comment.vue'),
        meta: {keepAlive: true, parentPath: 'message'},
    },
    
]
export default msg


// WEBPACK FOOTER //
// ./src/router/msg.js